var updateDatalayer = function updateDatalayer(
    eventName, productNumber, productName, quantity, price, currency) {

    if (window.gtm === undefined) {
        return;
    }

    let dataObject = null;

    // Create analytics object.
    if (eventName === 'add_to_cart' && window.gtm.config.add_to_cart) {

        dataObject = {
            'event' : 'add_to_cart',
            'ecommerce': { // [OR-56] set key to ecommerce
                'value': price * quantity,
                'currency': currency,
                'items': [{
                    'item_id': productNumber,
                    'item_name': productName,
                    'quantity': quantity,
                    'value': price,
                    'currency': currency,
                }]
            }
        };
    }
    else if (eventName === 'add_to_wishlist' && window.gtm.config.add_to_wishlist) {
        dataObject = {
            'event' : 'add_to_wishlist',
            'ecommerce': { // [OR-56] set key to ecommerce
                'value': price * quantity,
                'currency': currency,
                'items': [{
                    'item_id': productNumber,
                    'item_name': productName,
                    'quantity': quantity,
                    'value': price,
                    'currency': currency,
                }]
            }
        };
    }

    else if (eventName === 'remove_from_cart' && window.gtm.config.remove_from_cart) {
        dataObject = {
            'event' : 'remove_from_cart',
            'ecommerce': { // [OR-56] set key to ecommerce
                'value': price * quantity,
                'currency': currency,
                'items': [{
                    'item_id': productNumber,
                    'item_name': productName,
                    'quantity': quantity,
                    'value': price,
                    'currency': currency,
                }]
            }
        };
    }

    else if (eventName === 'view_item' && window.gtm.config.view_item) {
        dataObject = {
            'event' : 'view_item',
            'ecommerce': { // [OR-56] set key to ecommerce
                'value': price * quantity,
                'currency': currency,
                'items': [{
                    'item_id': productNumber,
                    'item_name': productName,
                    'quantity': quantity,
                    'value': price,
                    'currency': currency,
                }]
            }
        };
    }

// Check if analytics is enabled.
    if (typeof dataLayer != 'undefined' && dataObject != null){
        dataLayer.push(dataObject);
    }
}

export default updateDatalayer;
